import styled from 'styled-components';
import { colorWhite, mediaXs } from 'theme/theme-helper-selectors';

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const ContentLeft = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

export const ContentText = styled.h3`
    font-size: 30px;
    font-weight: 400;
    line-height: 36px;
    text-align: center;
    font-size: 24px;
`;

export const ContentTextLeft = styled(ContentText)`
    text-align: left;
`;

export const ButtonBlock = styled.div`
    display: flex;
    flex-direction: row;
    padding: 20px 0px;
    gap: 10px;
    width: 100%;
    justify-content: center;
    a {
        &:hover {
            color: ${colorWhite};
        }
    }
    @media (${mediaXs}) {
        flex-direction: column;
    }
`;
